import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import Grid from 'Components/Atoms/Grid/Grid';
import Title from 'Components/Atoms/Title/Title';
import EditButton from 'Components/Molecules/EditButton/EditButton';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { convertDateToMonthAndYear } from 'Services/Date/Date';
import { createCandidateValues, saveCandidateValues } from 'Store/Candidate/Actions';
import { CandidateId } from 'Store/Candidate/PropTypes';
import { getCandidate, getCandidateValuesFromCandidateId } from 'Store/Candidate/Selectors';
import { CANDIDATE_PREDEFINED, FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import containerStyles from './../../Organisms/LayoutContainer/LayoutContainer.module.sass';
import styles from './WorkExperiences.module.sass';

const calculateTimeDifference = (date1: any, date2: any) => {
    date1 = new Date(date1);
    date2 = !date2 ? new Date() : new Date(date2);

    let output = '';
    let monthDiff = date2.getMonth() - date1.getMonth() + 12 * (date2.getFullYear() - date1.getFullYear());
    monthDiff += date2.getDate() > 15 ? 1 : 0;

    const years = Math.floor(monthDiff /  12);
    const months = monthDiff % 12;
    if (years > 0) {
        output += years + ' jaar';
    }

    if (years > 0 && months > 0) {
        output += ' en ';
    }

    if (months > 0) {
        output += months + (months == 1 ? ' maand' : ' maanden');
    }

    if (years <= 0 && months <= 0) {
        output = "0 maanden";
    }

    return output;
}

const WorkExperiences = ({ entity_id, candidate, values, ...props}: WorkExperiencesProps) => {
    const [state, setState] = useState({ isEdit: false });

    const [data, setData] = useState(values?.[CANDIDATE_PREDEFINED.EXPERIENCE]?.value || []);
    useEffect(() => {
        setData(values?.[CANDIDATE_PREDEFINED.EXPERIENCE]?.value || []);
    }, [values]);

    const handleAddExperience = () => setData([
        ...data,
        {
            company: '',
            experiences: [
                {
                    title: '',
                    description: '',
                    start_date: '',
                    end_date: ''
                }
            ]
        }
    ]);

    const handleAddExperienceTitle = (idx: any) => {
        const tempData = [...data];

        const experiences = [
            ...tempData[idx]?.experiences,
            {
                title: '',
                description: '',
                start_date: '',
                end_date: ''
            }
        ];

        tempData[idx] = {
            ...tempData[idx],
            experiences
        };

        setData(tempData);
    }

    const handleDeleteExperienceTitle = (idx: number, expIdx: number) => {
        let tempData = [...data];

        const experienceTitles = tempData?.[idx]?.experiences;
        const titles = experienceTitles?.filter((_, tempIdx: number) => tempIdx != expIdx);

        if (!titles || titles?.length == 0) {
            const experiences = tempData?.filter((_, tempIdx: number) => tempIdx != idx);
            tempData = experiences;
        } else {
            tempData[idx] = {
                ...tempData[idx],
                experiences: titles
            }
        }
        
        setData(tempData);
    }

    const handleCancel = () => setData(values?.[CANDIDATE_PREDEFINED.EXPERIENCE]?.value || []);

    const handleSave = () => {
        data.forEach((item: any) => item.experiences.sort((a, b) => ((a.end_date || '9999-12-01') < (b.end_date || '9999-12-01')) ? 1 : -1));
        if (data.length > 0) data.sort((a, b) => ((a.experiences?.[0].end_date || '9999-12-01') < (b.experiences?.[0].end_date || '9999-12-01')) ? 1 : -1);

        if (values?.[CANDIDATE_PREDEFINED.EXPERIENCE]?.value_id) {
            props.saveCandidateValues(entity_id, {[values?.[CANDIDATE_PREDEFINED.EXPERIENCE]?.value_id]: data});
        } else {
            props.createCandidateValues(entity_id, {[CANDIDATE_PREDEFINED.EXPERIENCE]: data});
        }

        setState((state) => ({
            ...state,
            isEdit: false
        }));
    };

    return <div className={containerStyles['layoutcontainer']} style={{width: '100%'}}>
        <Grid
            position='between'
            align='center'
            axis='horizontal'
        >
            <Title weight='semibold'>Werk ervaringen</Title>
            
            <EditButton
                variant='button'
                isEdit={state.isEdit}
                onChange={(value) => setState({
                    ...state,
                    isEdit: value
                })}
                onSave={handleSave}
            />
        </Grid>

        { data.length === 0 &&
            <>
                { state.isEdit && <AddNew onClick={handleAddExperience}>+ Nieuwe werkgever toevoegen</AddNew> }
                { !state.isEdit && <div>Geen resultaten...</div> }
            </>
        }

        {
            data.map((item: any, idx: number) => {
                return <div className={styles['work_experience']}>
                    <div className={styles['work_experience-title']}>
                        {
                            state.isEdit &&
                            <FormGroup title='Bedrijfsnaam'>
                                <Field
                                    type={FieldType.Text}
                                    value={item?.company}
                                    isEdit={true}
                                    onChange={(value) => {
                                        const tempData = [...data];

                                        tempData[idx] = {
                                            ...tempData[idx],
                                            company: value
                                        }

                                        setData(tempData);
                                    }}
                                />
                            </FormGroup>
                        }
                        { !state.isEdit && item?.company }
                    </div>
                    <div className={styles['work_experience-list']}>
                        {
                            item?.experiences?.map((experience: any, expIdx: number) => {
                                return <>
                                    <div className={styles['work_experience-list-item']}>
                                        {
                                            !state.isEdit && <>
                                                <div className={styles['work_experience-list-item--side']}>
                                                    { convertDateToMonthAndYear(experience?.start_date) } - { experience?.end_date ? convertDateToMonthAndYear(experience?.end_date) : 'Heden' }
                                                </div>
                                                <div className={styles['work_experience-list-item--content']}>
                                                    <div className={styles['work_experience-list-item--content-title']}>
                                                        { experience?.title }
                                                    </div>
                                                    { experience?.description && <div dangerouslySetInnerHTML={{ __html: experience?.description }} ></div> }
                                                </div>
                                            </>
                                        }
                                        {
                                            state.isEdit && <>
                                                <div className={styles['work_experience-list-item--side']}>
                                                    <div className={styles['work_experience-list-item--side-date']}>
                                                        <FormGroup title='Start datum'>
                                                            <Field
                                                                type={FieldType.Date}
                                                                value={experience?.start_date}
                                                                isEdit={true}
                                                                onChange={(value) => {
                                                                    const tempData = [...data];

                                                                    const experiences = tempData[idx]?.experiences.map((item, index) => (index == expIdx) ? {...item, start_date: value} : item);
                        
                                                                    tempData[idx] = {
                                                                        ...tempData[idx],
                                                                        experiences
                                                                    }
                        
                                                                    setData(tempData);
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className={styles['work_experience-list-item--side-date']}>
                                                        <FormGroup title='Eind Datum'>
                                                            <Field
                                                                type={FieldType.Date}
                                                                value={experience?.end_date}
                                                                isEdit={true}
                                                                onChange={(value) => {
                                                                    const tempData = [...data];

                                                                    const experiences = tempData[idx]?.experiences.map((item, index) => (index == expIdx) ? {...item, end_date: value} : item);
                        
                                                                    tempData[idx] = {
                                                                        ...tempData[idx],
                                                                        experiences
                                                                    }
                        
                                                                    setData(tempData);
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    
                                                    { experience.start_date && <>
                                                        <div className={styles['work_experience-list-item--side-computed']}>
                                                            <strong>Datum: </strong> {`${convertDateToMonthAndYear(experience.start_date)} - ${experience.end_date ? convertDateToMonthAndYear(experience.end_date) : 'heden'} ` }
                                                        </div>
                                                        <div className={styles['work_experience-list-item--side-computed']}>
                                                            <strong>Duur: </strong> { calculateTimeDifference(experience.start_date, experience?.end_date) }
                                                        </div>
                                                    </> }

                                                    <div className={styles['delete']} onClick={() => handleDeleteExperienceTitle(idx, expIdx)}>Functie verwijderen</div>
                                                </div>
                                                <div className={styles['work_experience-list-item--content']}>
                                                    <div className={styles['work_experience-list-item--content-title']}>
                                                        <FormGroup title='Functietitel'>
                                                            <Field
                                                                type={FieldType.Text}
                                                                value={experience?.title}
                                                                isEdit={true}
                                                                onChange={(value) => {
                                                                    const tempData = [...data];
                        
                                                                    const experiences = tempData[idx]?.experiences.map((item, index) => (index == expIdx) ? {...item, title: value} : item);
                        
                                                                    tempData[idx] = {
                                                                        ...tempData[idx],
                                                                        experiences
                                                                    }
                        
                                                                    setData(tempData);
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div>
                                                        <FormGroup title='Functie omschrijving'>
                                                            <Field
                                                                type={FieldType.HTML_Editor}
                                                                value={experience?.description}
                                                                isEdit={true}
                                                                onChange={(value) => {
                                                                    const tempData = [...data];
                        
                                                                    const experiences = tempData[idx]?.experiences.map((item, index) => (index == expIdx) ? {...item, description: value} : item);
                        
                                                                    tempData[idx] = {
                                                                        ...tempData[idx],
                                                                        experiences
                                                                    }
                        
                                                                    setData(tempData);
                                                                }}
                                                                fieldProperties={{
                                                                    height: 400
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    {
                                                        item?.experiences.length-1 == expIdx &&
                                                            <AddNew onClick={() => handleAddExperienceTitle(idx)}>+ Nieuwe functie toevoegen</AddNew>
                                                    }
                                                </div>
                                            </>
                                        }
                                    </div>
                                </>;
                            })
                        }
                    </div>

                    { state.isEdit && data?.length-1 == idx && <AddNew onClick={handleAddExperience}>+ Nieuwe werkgever toevoegen</AddNew>}
                </div>
            })
        }
    </div>
}

interface Props {
    entity_id: CandidateId
}

const mapState = (state: StoreState, props: Props) => ({
    candidate: getCandidate(state, props.entity_id),
    values: getCandidateValuesFromCandidateId(state, props.entity_id)
});

const mapDispatch = {
    saveCandidateValues,
    createCandidateValues
};


type WorkExperiencesProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(WorkExperiences);